import { HttpClient as i } from "./index.es488.js";
import { sendTelemetryMetrics as p, sendTelemetryLog as P } from "./index.es489.js";
import { uploadPoisJob as d, getUploadPoisJobStatus as T, shareMapDocument as c, deleteMapDocument as M, updateMapDocument as C, createMapDocument as I, getLastSavedMapDocument as D, getMapDocument as k, listMapDocuments as A, getMapTemplate as O, listMapTemplates as b } from "./index.es490.js";
import { getReverseGeocode as S } from "./index.es491.js";
import { getPortfolioTagEntities as h, getComplexTenants as U, getEntitiesRankingV2 as y, getChainVenues as $, getTagEntities as V, updateTag as v, createTag as f, getTag as R, getTags as w, getPrintStatus as E, createPrint as G, getTagVisits as L, getPOIReportAccess as B, getSales as x, getDwellTime as J, getVisitFrequency as N, getVisitors as H, getPOIVisitsAudience as q, getPOIVisits as F, getNearbyReportStatus as j, getPOIData as z, getCustomPOIStatus as K, createSlimCustomPOI as Q, updateCustomPOI as W, createCustomPOI as X, createPOIResponse as Y, searchEntities as Z, getChainsByCategories as _, getCategories as ee, getGeoTradeAreaHeatmap as te, getChainVenueRankingPOI as ae, getNearbyRankingPOI as se, getUserPermittedPlugins as ie, sendSplunkBulk as ge, getUserPermissions as oe, getUserCustomSettings as ne, getUserConfig as re, getEntitiesV2 as le } from "./index.es492.js";
import { getMarketStats as me, getMarketPopEmployees as ue, getMarketPopulation as pe, getPersonaLiveData as Pe, getPopstatsData as de, getMosaicData as Te, getCensusData as ce, getGeoTradeAreaChainCbgs as Me, getGeoTradeAreaCbgs as Ce, getGeoTradeAreaPolygon as Ie } from "./index.es493.js";
import { getPremiumLayerPermissions as De, getChainTilesTTAMetadata as ke } from "./index.es494.js";
import { getChainTilesTaBatchId as Ae } from "./index.es495.js";
import { updatePOIMetadata as Oe, createTagMetadata as be, listTagMetadata as Se, getTagMetadata as he } from "./index.es496.js";
const Ge = ({ token: g, endpoints: t }) => {
  const o = new i({
    token: g,
    baseUrl: (t == null ? void 0 : t.guruAdminAPI) || ""
  }), e = new i({
    token: g,
    baseUrl: (t == null ? void 0 : t.guruAPI) || ""
  }), n = new i({
    token: g,
    baseUrl: (t == null ? void 0 : t.esetAPI) || ""
  }), a = new i({
    token: g,
    baseUrl: (t == null ? void 0 : t.mapDocumentAPI) || ""
  }), s = new i({
    token: g,
    baseUrl: (t == null ? void 0 : t.tradeAreaAPI) || ""
  }), l = new i({
    token: g,
    baseUrl: (t == null ? void 0 : t.feTelemetryAPI) || ""
  }), m = new i({
    token: g,
    baseUrl: (t == null ? void 0 : t.staticTilesAPI) || ""
  }), u = new i({
    token: g,
    baseUrl: (t == null ? void 0 : t.siteSelectionAPI) || ""
  }), r = new i({
    token: g,
    baseUrl: (t == null ? void 0 : t.mapStudioPortfolioMetadataAPI) || ""
  });
  return {
    //FeTelemetryService
    sendTelemetryLog: P(l),
    sendTelemetryMetrics: p(l),
    //MapDocumentService
    listMapTemplates: b(a),
    getMapTemplate: O(a),
    listMapDocuments: A(a),
    getMapDocument: k(a),
    getLastSavedMapDocument: D(a),
    createMapDocument: I(a),
    updateMapDocument: C(a),
    deleteMapDocument: M(a),
    shareMapDocument: c(a),
    getUploadPoisJobStatus: T(a),
    uploadPoisJob: d(a),
    //MapboxService
    getReverseGeocode: S(
      new i({
        baseUrl: "https://api.mapbox.com"
      })
    ),
    //TradeAreaService
    getGeoTradeAreaPolygon: Ie(s),
    getGeoTradeAreaCbgs: Ce(s),
    getGeoTradeAreaChainCbgs: Me(s),
    getEntitiesV2: le(e),
    getCensusData: ce(s),
    getMosaicData: Te(s),
    getPopstatsData: de(s),
    getPersonaLiveData: Pe(s),
    getMarketPopulation: pe(s),
    getMarketPopEmployees: ue(s),
    getMarketStats: me(s),
    //GuruAdminService
    getUserConfig: re(o),
    getUserCustomSettings: ne(o),
    getUserPermissions: oe(o),
    sendSplunkBulk: ge(o),
    getUserPermittedPlugins: ie(o),
    //GuruService
    getNearbyRankingPOI: se(e),
    getChainVenueRankingPOI: ae(e),
    getGeoTradeAreaHeatmap: te(e),
    getCategories: ee(e),
    getChainsByCategories: _(e),
    searchEntities: Z(e),
    createPOIResponse: Y(e),
    createCustomPOI: X(e),
    updateCustomPOI: W(e),
    createSlimCustomPOI: Q(e),
    getCustomPOIStatus: K(e),
    getPOIData: z(e),
    getNearbyReportStatus: j(e),
    getPOIVisits: F(e),
    getPOIVisitsAudience: q(e),
    getVisitors: H(e),
    getVisitFrequency: N(e),
    getDwellTime: J(e),
    getSales: x(e),
    getPOIReportAccess: B(e),
    getTagVisits: L(e),
    createPrint: G(e),
    getPrintStatus: E(e),
    getTags: w(e),
    getTag: R(e),
    createTag: f(e),
    updateTag: v(e),
    getTagEntities: V(e),
    // Eset Service
    getChainVenues: $(n),
    getEntitiesRankingV2: y(n),
    getComplexTenants: U(n),
    getPortfolioTagEntities: h(n),
    // Static-tiles Service
    getChainTilesTTAMetadata: ke(m),
    getPremiumLayerPermissions: De(m),
    //Site Selection Service
    getChainTilesTaBatchId: Ae(u),
    //Mapstudio Portfolio Metadata Service
    getTagMetadata: he(
      r
    ),
    listTagMetadata: Se(
      r
    ),
    createTagMetadata: be(
      r
    ),
    updatePOIMetadata: Oe(
      r
    )
  };
};
export {
  Ge as APIClient
};
//# sourceMappingURL=index.es453.js.map
